const my_profile = {
  viewMyClubSeacretProfile: "Lihat Profil ClubSecret Saya", // translated
  viewMoreDetails: "Lihat Lebih Detail", // translated
  verifiedEmail: "Email Terverifikasi", // translated
  unverifiedEmail: "Email Belum Diverifikasi", // translated
  balance: "Keseimbangan", // translated
  pointsIn: "Poin Masuk", // translated
  pointsOut: "Menunjukkan", // translated
  topUp: "Isi Ulang", // translated
  pointsHistoryTable: "Tabel Riwayat Poin", // translated
  createdFrom: "Dibuat dari", // translated
  createdTo: "Dibuat hingga", // translated
  selectStatus: "Pilih status...", // translated
  searchByTitle: "Cari berdasarkan judul...", // translated
  offerStatus: "Status Penawaran", // translated
  selectOfferStatus: "Semua", // translated
  quotationSent: "Penawaran Terkirim", // translated
  offerInProgress: "Penawaran Sedang Diproses", // translated
  offerAvailable: "Penawaran Tersedia", // translated
  offerAccepted: "Penawaran Diterima", // translated
  offerExpired: "Penawaran Kedaluwarsa", // translated
  offerReference: "Referensi Penawaran", // translated
  tripStartDate: "Tanggal Mulai Perjalanan", // translated
  dueDate: "Tanggal Jatuh Tempo", // translated
  viewOffer: "Lihat Penawaran", // translated
  notApplicable: "T/A", // translated
  manageSubscription: "Kelola Langganan", // translated
  logoAndColors: "Logo & Warna", // translated
  editColors: "Ubah Warna", // translated
  editLogo: "Ubah Logo", // translated
  primaryColor: "Warna Primer", // translated
  secondaryColor: "Warna Sekunder", // translated
  subagentLogoAlt: "Logo Subagen", // translated
  pickColors: "Pilih Warna", // translated
  logoPreview: "Pratinjau Logo", // translated
  logoPreviewAlt: "Pratinjau logo", // translated
  noLogoSelected: "Tidak ada logo yang dipilih", // translated
  changeLogo: "Ubah Logo", // translated
  uploadLogo: "Unggah Logo", // translated
  supportedImageFormats: "Format yang didukung: JPG, PNG. Ukuran maks: 2MB", // translated
  saving: "Menyimpan...", // translated
  logoUpdatedSuccess: "Logo berhasil diperbarui", // translated
  failedToUpdateLogo: "Gagal memperbarui logo", // translated
  colorsUpdatedSuccess: "Warna berhasil diperbarui", // translated
  failedToUpdateColors: "Gagal memperbarui warna", // translated
  selectImageFile: "Silakan pilih file gambar", // translated
  imageSizeLimit: "Ukuran gambar harus kurang dari 5MB", // translated
  pushNotifications: "Notifikasi Push", // translated
  pushNotificationsDescription: "Terima notifikasi browser untuk pembaruan dan acara penting", // translated
  pushNotificationsNotSupported: "Notifikasi push tidak didukung di browser ini", // translated
  pushNotificationsDeniedMessage:
    "Izin notifikasi ditolak. Harap aktifkan notifikasi di pengaturan browser untuk menerima notifikasi push.", // translated
  pushNotificationsEnabled: "Notifikasi push berhasil diaktifkan", // translated
  pushNotificationsDisabled: "Notifikasi push berhasil dinonaktifkan", // translated
  userInformationMissing: "Informasi pengguna hilang", // translated
  failedToUpdatePushNotifications: "Gagal memperbarui pengaturan notifikasi push", // translated
  notificationPermissionDenied: "Izin notifikasi ditolak. Harap aktifkan di pengaturan browser.", // translated
  notificationPermissionRequired: "Izin notifikasi diaktifkan untuk mengaktifkan notifikasi push", // translated
  notSupported: "Tidak didukung", // translated
  permissionDenied: "Izinkan ditolak", // translated
  permissionNotRequested: "Izin tidak diminta", // translated
  enabled: "Diaktifkan", // translated
  disabled: "Dinonaktifkan", // translated
};

export default my_profile;
